import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'

export const TextHeaderEs = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    return (
        <HighlightedText
            text="GIRA LA RUEDA Y CONSIGUE GIROS GRATIS"
            highlights={[{ word: 'GIROS' }, { word: 'GRATIS' }]}
            breakAfterWords={isDesktop ? ['CONSIGUE'] : ['RUEDA', 'CONSIGUE']}
            className={common.text_header}
        />
    )
}
